/* eslint-disable jsx-a11y/anchor-is-valid */
import * as React from 'react'

import {
  Button,
  Modal,
  Space,
  TextBody,
  useModal,
  TextHeading,
} from '@ally/metronome-ui'

type ModalTextBody = 'enroll' | 'forgotPassword'

interface ModalTextBodyProps {
  textBodyType?: ModalTextBody
  withAllyTM?: string
}

const enrollTextBody =
  "We use your Social Security number to verify your identity and link your accounts to the username and password you're setting up now."
const forgotPasswordTextBody =
  "Before you change your username or password, we'll confirm it's you by comparing the SSN you enter with the one we have on file."

const defaultTextBody = enrollTextBody

const headingRef = React.createRef<HTMLHeadingElement>()

const ModalContent: React.FC<ModalTextBodyProps> = ({ textBodyType }) => {
  const [textBody, setTextBody] = React.useState(defaultTextBody)
  React.useEffect(() => {
    if (textBodyType === 'forgotPassword') {
      setTextBody(forgotPasswordTextBody)
    }
  }, [])
  return (
    <>
      <Space mb="md">
        <TextHeading tag="h1" size="md" tabIndex={-1} ref={headingRef}>
          Why do we need your Social Security number?
        </TextHeading>
      </Space>
      <Space mb="md">
        <TextBody tag="p" size="md">
          {textBody}
        </TextBody>
      </Space>
    </>
  )
}

const ModalTriggerComponent: React.FC<{ withAllyTM: string }> = ({
  withAllyTM,
}) => {
  const { showModal } = useModal()

  return (
    <Button
      withAllyTM={withAllyTM}
      variant="link"
      text="Why we ask for your SSN"
      onClick={showModal}
    />
  )
}

export const SSNModal: React.FC<ModalTextBodyProps> = ({
  textBodyType = 'enroll',
  withAllyTM = 'whyWeAskForYourSSN',
}) => (
  <Modal
    ref={headingRef}
    content={<ModalContent textBodyType={textBodyType} />}
    trigger={<ModalTriggerComponent withAllyTM={withAllyTM} />}
  />
)
